import React, { Component, useEffect, useState } from "react";
import educationMaterial from "../../../files/white_on_transparent.png";
import { Nav, NavItem, NavLink, Row } from "reactstrap";
import classNames from "classnames";
import CreateEducationMaterialModal from "./AddEducationMaterial";
import EducationList from "./EducationList";
import { useFetch2 } from "../../utils/authenticatedHook";
import encryptRequest from "../../../helpers/encryptationHelper";
import { pasteValue } from "../../Reusable/OnPasteValue";

function EducationModule() {
  const [{ response, error, isLoading }, doFetch, sendError] = useFetch2();
  const [addModal, setAddModal] = useState(false);
  const [requestData, setRequestData] = useState(true);
  const [editDetails, setEditDetails] = useState(null)

  function getEducationMaterial(filter) {
    const query = {
      page: filter?.page ?? 1,
      limit: filter?.limit ?? 25,
      sortOrder: filter?.sortOrder ?? "desc",
      sortFiled: filter?.sortFiled ?? "createdAt",
    };
    if (filter && filter.search) {
      query.search = filter.search;
    }
    doFetch({
      url: "/get-education-material",
      method: "GET",
      disableWait: true,
      query: query,
    });
  }
  function handleDelete(event) {
    if (event && event._id) {
      setRequestData(true);
      doFetch({
        url: "/delete-education-material/" + encryptRequest(event._id),
        method: "DELETE",
        disableWait: true,
        message: event.isActive ? "Educational material has been deactivated successfully." : "Educational material has been activated successfully.",
      });
    }
  }
  function handalToggleModal(event) {
    setAddModal(!addModal);
    setEditDetails(null)
    if (event == "reload") {
      getEducationMaterial();
      setRequestData(true);
    }
  }
  function paginationEducationList(
    type,
    { page, sizePerPage, filters, sortField, sortOrder }
  ) {
    let data = {
      page: page,
      limit: sizePerPage,
    };
    if (sortField) {
      data.sortFiled = sortField;
    }
    if (sortOrder) {
      data.sortOrder = sortOrder;
    }
    getEducationMaterial(data);
  }
  let debounceTimeout;
  function handleSearch(event) {
    const value = event.target.value;

    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      getEducationMaterial({ search: value });
    }, 500);
  }
  function handleEdit(editData) {
    if (editData && Object.keys(editData).length > 0) {
      setEditDetails(editData);
      setAddModal(true);
    }
  }
  useEffect(() => {
    if (!isLoading && requestData) {
      getEducationMaterial();
      setRequestData(false);
    }
  }, [isLoading]);

  useEffect(() => {
    getEducationMaterial();
  }, []);
  return (
    <div>
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body project-tab pt-2">
              <Nav tabs className="justify-content-center">
                <NavItem>
                  <NavLink className={classNames({ active: true })}>
                    <img
                      className="img-tabsfluid"
                      src={educationMaterial}
                      style={{ marginRight: 5 }}
                      fill="red"
                    />
                    EDUCATIONAL MATERIAL
                  </NavLink>
                </NavItem>
              </Nav>
              <Row style={{ marginTop: 25 }}>
                <div className="d-flex flex-column flex-md-row w-100 align-items-stretch align-items-md-center mb-3" style={{ gap: '12px' }}>
                  <input
                    type="text"
                    className="form-control input-date-filter remove-bottom-margin mb-2 mb-md-0"
                    id="exampleInputName1Test"
                    style={{
                      fontSize: "18px",
                      borderRadius: "8px",
                      boxShadow: "none",
                      height: "44px",
                      flex: 1,
                      minWidth: '0', // Prevents flex item from overflowing
                    }}
                    placeholder="Search Material type, Note..."
                    onChange={handleSearch} // Call handleChange on every input change
                    onPaste={(e) => {
                      e.preventDefault();
                      const event = pasteValue(e);
                      handleSearch(event);
                    }}
                  />
                  <button
                    className="btn btn-info d-flex align-items-center justify-content-center"
                    style={{
                      borderRadius: "8px",
                      fontWeight: 500,
                      fontSize: "16px",
                      padding: "10px 18px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                      whiteSpace: "nowrap",
                      minHeight: "44px", // Ensure consistent touch target
                    }}
                    onClick={() => setAddModal(true)}
                  >
                    <i className="mdi mdi-plus-circle-outline mr-1 mr-md-2" style={{ fontSize: "20px" }} />
                    <span className="d-none d-sm-inline">Add Educational Material</span>
                    <span className="d-sm-none">Add</span>
                  </button>
                </div>
                <div className="w-100 mt-4">
                  <EducationList
                    loading={isLoading}
                    educationMaterialData={
                      response && response.educationMaterialData
                        ? response.educationMaterialData
                        : []
                    }
                    handleDelete={handleDelete}
                    pagination={paginationEducationList}
                    handleEdit={handleEdit}
                  ></EducationList>
                </div>
              </Row>
            </div>
          </div>
        </div>
      </div>
      {addModal && (
        <CreateEducationMaterialModal
          addModal={addModal}
          toggleModal={handalToggleModal}
          editData={editDetails}
        />
      )}
    </div>
  );
}

export default EducationModule;
